// actions.js
import Axios from 'axios'
import { bookingUrls, gateUrls } from '../urls'
import router from '../../../router'

export default {
  get_all_gates(context) {
    Axios.get(gateUrls.getAllGates).then(function (response) {
      context.commit('GET_ALL_GATES', response.data)
    })
  },
  get_gates(context, publicId) {
    Axios.get(gateUrls.getGates + publicId).then(function (response) {
      context.commit('GET_GATES', response.data)
    })
  },
  get_deleted_gates(context) {
    Axios.get(gateUrls.getDeletedGate).then(function (response) {
      context.commit('GET_DELETED_GATES', response.data)
    })
  },
  get_gate(context, publicId) {
    Axios.get(gateUrls.getGate + publicId).then(function (response) {
      context.commit('GET_GATE', response.data)
    })
  },
  post_gate(context, data) {
    Axios.post(gateUrls.postGate, data).then(function () {
      context.dispatch('get_all_gates')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },

  update_gate(context, data) {
    Axios.post(gateUrls.editGate, data).then(function () {
      context.dispatch('get_all_gates')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_gate(context, data) {
    Axios.patch(gateUrls.deleteGate, data).then(function (response) {
      context.commit('GET_DELETED_GATES', response.data)
      context.dispatch('get_all_gates')
      router.push({
        name: 'BookingSettings'
      })
    })
  },
  restoreGate(context, publicId) {
    Axios.get(gateUrls.restoreGate + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_GATES', response.data)
      router.push({
        name: 'Module.Gates'
      })
    })
  },
  get_all_entry_modes(context) {
    Axios.get(gateUrls.getAllEntryModes).then(function (response) {
      context.commit('GET_ALL_ENTRY_MODES', response.data)
    })
  },
  post_entry_mode(context, data) {
    Axios.post(gateUrls.postEntryMode, data).then(function () {
      context.dispatch('get_all_entry_modes')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_entry_mode(context, data) {
    Axios.post(gateUrls.editEntryMode, data).then(function () {
      context.dispatch('get_all_entry_modes')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_entry_mode(context, data) {
    Axios.patch(gateUrls.deleteEntryMode, data).then(function (response) {
      context.dispatch('get_all_entry_modes')
      router.push({
        name: 'BookingSettings'
      })
    })
  },
  get_unticketed_vehicles(context) {
    //Axios.get(gateUrls.getUnticketedVehicles).then(function (response) {
    Axios.get(bookingUrls.getUnticketedAlertedBooking).then(function (response) {
    context.commit('UNTICKETED_VEHICLES_DATA', response.data)
    }).catch(function (error) {
      console.log(error)
    })
  },
}
